var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1215_7792",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1215_7792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 13.5834L7.48325 10.7333L8.53325 9.66668L10.3333 11.4667L14.1666 7.63335L15.2166 8.70002L10.3333 13.5834ZM14.4333 6.45002H12.8499V3.15002H11.9333V4.85002H4.06659V3.15002H3.14992V12.85H7.18325V14.4167H3.14992C2.70514 14.4167 2.33286 14.2694 2.03309 13.9748C1.7332 13.6803 1.58325 13.3054 1.58325 12.85V3.15002C1.58325 2.69479 1.73053 2.31707 2.02509 2.01685C2.31964 1.71674 2.69459 1.56668 3.14992 1.56668H6.04992C6.17214 1.16668 6.4122 0.836127 6.77009 0.575016C7.12786 0.313905 7.53781 0.18335 7.99992 0.18335C8.44436 0.18335 8.84714 0.313905 9.20825 0.575016C9.56936 0.836127 9.82214 1.16668 9.96659 1.56668H12.8499C13.3051 1.56668 13.6829 1.71674 13.9831 2.01685C14.2832 2.31707 14.4333 2.69479 14.4333 3.15002V6.45002ZM7.99992 2.96668C8.18881 2.96668 8.34714 2.90002 8.47492 2.76668C8.6027 2.63335 8.66659 2.47779 8.66659 2.30002C8.66659 2.11113 8.6027 1.95279 8.47492 1.82502C8.34714 1.69724 8.18881 1.63335 7.99992 1.63335C7.81103 1.63335 7.6527 1.69724 7.52492 1.82502C7.39714 1.95279 7.33325 2.11113 7.33325 2.30002C7.33325 2.47779 7.39714 2.63335 7.52492 2.76668C7.6527 2.90002 7.81103 2.96668 7.99992 2.96668Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.4f00c37ed3ae6946c8409a5615df65c3.svg";
export { ForwardRef as ReactComponent };